import * as React from 'react';
import { Fragment } from 'react';
import { ReportSettings, ReportSettingsChangeHandler } from 'logic/reports/ReportSettings';
import { Recurrence } from './recurrence/Recurrence';
import { ScheduleRange } from './ScheduleRange';

export type OwnProps = {
    reportSettings: Readonly<ReportSettings>;
    onChange: ReportSettingsChangeHandler;
};

export const RunOnSchedule = (props: OwnProps) =>
    <Fragment>
        <Recurrence { ...props }/>
        <ScheduleRange { ...props }/>
    </Fragment>
;



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/schedule/runOnSchedule/RunOnSchedule.tsx